<template>

    <v-modal title="Edit Color">
        <template #body>
            <form @keydown.enter.prevent="submit">
                <v-input-color id="color" size="sm" position="bottom" :model="params.color" @input="params.color = $event" />
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="dismiss">Cancel</v-button>
            <v-button size="sm" @click.native="submit">Save</v-button>
        </template>
    </v-modal>

</template>

<script>

import Modal from './Modal';

export default {

    components: {
        'v-modal': Modal,
    },

    data() {
        return {
            params: {},
        }
    },

    computed: {

        modalParams() {
            return this.$store.getters['builder/selectedModalParams'];
        },

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

    },

    created() {
        let parent = this.modalParams.range?.startContainer?.parentNode;
        if (parent?.tagName === 'FONT') {
            this.params.color = parent.getAttribute('color') || this.block.color;
        } else if (parent?.tagName === 'A') {
            this.params.color = parent.style['color'] || this.block.link_color;
        } else if (parent?.tagName === 'SPAN') {
            this.params.color = parent.style['color'] || this.block.color;
        } else {
            this.params.color = this.block.color;
        }
    },

    mounted() {
        document.getElementById('color').getElementsByClassName('input')[0].focus();
    },

    methods: {

        submit() {
            if (this.modalParams.range) {
                let sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(this.modalParams.range);
                document.execCommand('ForeColor', false, this.params.color);
                sel.empty();
            }
            this.dismiss();
        },

        dismiss() {
            this.$store.commit('builder/setSelectedModal', null);
        },

    },

}

</script>